export const IMANAGE_PROVIDER_PORTAL_URL = "https://cloudimanage.com/";